// Read-only subscription page for the merchant. Admin manages billing —
// this page just shows the current tier, status, commission rate, and notes.

import React, { useEffect, useState } from 'react';
import { getSubscription } from '../../services/merchantService';

export default function MerchantSubscription() {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let alive = true;
    getSubscription()
      .then(d => { if (alive) setData(d); })
      .catch(e => { if (alive) setError(e?.response?.data?.error || e.message); });
    return () => { alive = false; };
  }, []);

  if (error) return <><div className="portal-content-header"><h1>Subscription</h1></div><div className="portal-error">{error}</div></>;
  if (!data) return <><div className="portal-content-header"><h1>Subscription</h1></div><div className="portal-empty">Loading…</div></>;

  const sub = data.subscription;

  return (
    <>
      <div className="portal-content-header">
        <h1>
          Subscription
          {sub && <span className={`badge badge-${sub.status === 'active' ? 'active' : 'pending'}`}>{sub.tier} · {sub.status}</span>}
        </h1>
      </div>

      {!sub && (
        <div className="portal-card warn">
          <strong style={{ color: 'var(--tudu-text-hi)' }}>No subscription on file.</strong>
          <p style={{ margin: 'var(--tudu-space-2) 0 0' }}>
            Reach out to your account admin to provision a tier. Flyer uploads are
            blocked until a subscription is active.
          </p>
        </div>
      )}

      {sub && (
        <div className="portal-card">
          <div className="portal-defs">
            <Def label="Tier" value={sub.tier} />
            <Def label="Status" value={sub.status} />
            <Def label="Commission" value={`${(parseFloat(sub.commission_rate) * 100).toFixed(2)}%`} />
            <Def label="Monthly fee" value={`$${sub.monthly_fee}`} />
            <Def label="Started" value={new Date(sub.started_at).toLocaleDateString()} />
            <Def label="Period end" value={sub.current_period_end ? new Date(sub.current_period_end).toLocaleDateString() : '—'} />
          </div>
          {sub.notes && (
            <div style={{ marginTop: 'var(--tudu-space-4)', padding: 'var(--tudu-space-3)', background: 'var(--tudu-bg-3)', borderRadius: 'var(--tudu-radius-sm)' }}>
              <strong style={{ color: 'var(--tudu-text-hi)' }}>Notes from admin:</strong>
              <div style={{ marginTop: 'var(--tudu-space-2)', whiteSpace: 'pre-wrap', color: 'var(--tudu-text)' }}>{sub.notes}</div>
            </div>
          )}
        </div>
      )}

      <div className="portal-card info">
        <strong style={{ color: 'var(--tudu-text-hi)' }}>How billing works</strong>
        <p style={{ margin: 'var(--tudu-space-2) 0 0' }}>
          We're not currently processing payments through the portal — your admin handles
          tier changes and invoicing manually. Commission rates apply to revenue tracked
          against your coupons and flyers.
        </p>
      </div>
    </>
  );
}

function Def({ label, value }) {
  return (
    <div>
      <div className="portal-def-label">{label}</div>
      <div className="portal-def-value">{value}</div>
    </div>
  );
}
